import { FILTER_TYPES } from '@/js/helper/message-center-constants.js'
import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'
import { CONSTANTS as MESSAGE_CENTER_CONSTANTS } from '@/js/helper/message-center-constants.js'
import { DP_ROLE } from '@/js/helper/dp-usermanagement-constants'
import HubspotScriptMixin from '@/js/mixins/hubspot-script-mixin.js'
import { HUBSPOT_SUPPORTPORTAL_URLS } from '@/js/components/HubSpot/Helpers/hubspot-constants.js'

export default {
  mixins: [HubspotScriptMixin],
  methods: {
    generateMessageCenterLinkTiles() {
      const routerPath =
        this.$router.resolve({ name: MESSAGE_CENTER_CONSTANTS.ROUTES.LIST })?.href ?? ''
      const baseUrl = new URL(routerPath, `${window.location.origin}${window.location.pathname}`)
        .href

      const linkTiles = [
        {
          show:
            this.hasRole(DP_ROLE.MESSAGING_TICKETS_R.p) && this.hasRole(DP_ROLE.TYPO3_FOCUS_L.p),
          uid: 10000,
          type: 'linktile',
          pageId: '10000',
          target: '_blank',
          id: 10000,
          links: {
            self: 'api/bucommonapi?code=content&contentId=1&uid=10000',
          },
          attributes: {
            icon: 'message-center-tickets',
            title: this.$t('messages.customer_portal.focus'),
            url: HUBSPOT_SUPPORTPORTAL_URLS.FOCUS,
            component: '',
            badge_date: '',
          },
        },
        {
          show:
            this.hasRole(DP_ROLE.MESSAGING_TICKETS_R.p) && this.hasRole(DP_ROLE.TYPO3_KALKHOFF_L.p),
          uid: 10001,
          type: 'linktile',
          pageId: '10001',
          target: '_blank',
          id: 10001,
          links: {
            self: 'api/bucommonapi?code=content&contentId=1&uid=10001',
          },
          attributes: {
            icon: 'message-center-tickets',
            title: this.$t('messages.customer_portal.kalkhoff'),
            url: HUBSPOT_SUPPORTPORTAL_URLS.KALKHOFF,
            component: '',
            badge_date: '',
          },
        },
        // {
        //   show: this.hasRole(DP_ROLE.TYPO3_URBANARROW_L.p),
        //   uid: 10002,
        //   type: 'linktile',
        //   pageId: '10002',
        //   target: '_blank',
        //   id: 10002,
        //   links: {
        //     self: 'api/bucommonapi?code=content&contentId=1&uid=10002',
        //   },
        //   attributes: {
        //     icon: 'message-center-tickets',
        //     title: this.$t('messages.customer_portal.urbanarrow'),
        //     url: HUBSPOT_SUPPORTPORTAL_URLS.URBANARROW,
        //     component: '',
        //     badge_date: '',
        //   },
        // },
        {
          show: this.hasRole(DP_ROLE.MESSAGING_INFORMATIONS_R.p),
          uid: 9998,
          type: 'linktile',
          pageId: '9998',
          id: 9998,
          links: {
            self: 'api/bucommonapi?code=content&contentId=1&uid=9998',
          },
          attributes: {
            icon: 'message-center-infos',
            title: this.$t(`messages.filter.${FILTER_TYPES.INFO}`),
            url: `${baseUrl}?tab=info`,
            component: '',
            badge_date: '',
          },
        },
        {
          show: this.hasRole(DP_ROLE.MESSAGING_NEWS_R.p),
          uid: 9999,
          type: 'linktile',
          pageId: '9999',
          id: 9999,
          links: {
            self: 'api/bucommonapi?code=content&contentId=1&uid=9999',
          },
          attributes: {
            icon: 'message-center-news',
            title: this.$t(`messages.filter.${FILTER_TYPES.NEWS}`),
            url: `${baseUrl}?tab=news`,
            component: '',
            badge_date: '',
          },
        },
      ]

      return linkTiles.filter(i => i.show)
    },
    generateProductsListLinkTiles() {
      const bikePath = this.$router.resolve({ name: FILTER_CONSTANTS.SCOPE.BIKES })?.href ?? ''
      const sparepartPath =
        this.$router.resolve({ name: FILTER_CONSTANTS.SCOPE.SERVICE })?.href ?? ''
      const sparepartSalePath =
        this.$router.resolve({ name: FILTER_CONSTANTS.SCOPE.PART_SALE })?.href ?? ''
      const accessoriesPath =
        this.$router.resolve({ name: FILTER_CONSTANTS.SCOPE.ACCESSORIES })?.href ?? ''

      const bikeUrl = new URL(bikePath, `${window.location.origin}${window.location.pathname}`).href
      const sparepartUrl = new URL(
        sparepartPath,
        `${window.location.origin}${window.location.pathname}`,
      ).href
      const sparepartSaleUrl = new URL(
        sparepartSalePath,
        `${window.location.origin}${window.location.pathname}`,
      ).href
      const accessoriesUrl = new URL(
        accessoriesPath,
        `${window.location.origin}${window.location.pathname}`,
      ).href

      return [
        {
          show: this.hasRole(DP_ROLE.SHOP_BIKES_R.p) && this.hasScope(this.SCOPES.BIKES),
          uid: 9995,
          type: 'linktile',
          pageId: '9995',
          id: 9995,
          links: {
            self: 'api/bucommonapi?code=content&contentId=1&uid=9995',
          },
          attributes: {
            icon: 'bike',
            title: this.$t(`filter.scope.summaryTitle.BIKES`),
            url: bikeUrl,
            component: '',
            badge_date: '',
          },
        },
        {
          show: this.hasRole(DP_ROLE.SHOP_PARTS_R.p) && this.hasScope(this.SCOPES.SERVICE),
          uid: 9996,
          type: 'linktile',
          pageId: '9996',
          id: 9996,
          links: {
            self: 'api/bucommonapi?code=content&contentId=1&uid=9996',
          },
          attributes: {
            icon: 'service',
            title: this.$t(`filter.scope.summaryTitle.SERVICE`),
            url: sparepartUrl,
            component: '',
            badge_date: '',
          },
        },
        {
          show: this.hasRole(DP_ROLE.TYPO3_SALE_L.p) && this.hasScope(this.SCOPES.PART_SALE),
          uid: 99961,
          type: 'linktile',
          pageId: '99961',
          id: 99961,
          links: {
            self: 'api/bucommonapi?code=content&contentId=1&uid=99961',
          },
          attributes: {
            icon: 'service',
            title: this.$t(`filter.scope.summaryTitle.PART_SALE`),
            url: sparepartSaleUrl,
            component: '',
            badge_date: '',
          },
        },
        {
          show:
            this.hasRole(DP_ROLE.SHOP_ACCESSORIES_R.p) && this.hasScope(this.SCOPES.ACCESSORIES),
          uid: 9997,
          type: 'linktile',
          pageId: '9997',
          id: 9997,
          links: {
            self: 'api/bucommonapi?code=content&contentId=1&uid=9997',
          },
          attributes: {
            icon: 'accessories',
            title: this.$t(`filter.scope.summaryTitle.ACCESSORIES`),
            url: accessoriesUrl,
            component: '',
            badge_date: '',
          },
        },
      ].filter(i => i.show)
    },
  },
}
